import Decimal from 'decimal.js';
import { Typography } from 'seagull';
import { serviceCostModel, serviceTemplateModel } from "../../../models";
import { utils } from "../../../utils";
import styles from "./ServicePicker.module.scss";
import { getDiscountedPriceByServiceTemplate } from "./ServicePicker.utils";
import { jsxs as _jsxs, Fragment as _Fragment, jsx as _jsx } from "react/jsx-runtime";
export default function ServicePickerPriceLabel(_ref) {
  let {
    service
  } = _ref;
  const {
    cost
  } = service;
  const {
    discount
  } = cost;
  const hasDiscount = !!discount && discount.amount().greaterThan(0);
  const discountedPrice = getDiscountedPriceByServiceTemplate(service);
  return /*#__PURE__*/_jsx(Typography, {
    ellipsis: true,
    skin: "secondary",
    className: styles.priceLabel,
    "data-testid": "uneditable-service-picker-row-price-label",
    tooltipProps: {
      title: discountedPrice == null ? '' : discountedPrice instanceof Decimal ? /*#__PURE__*/_jsxs(_Fragment, {
        children: [utils.formatDollarAmount(discountedPrice), hasDiscount && /*#__PURE__*/_jsxs(_Fragment, {
          children: [' ', /*#__PURE__*/_jsxs("del", {
            children: ["$", utils.formatNumberWithCommas(serviceTemplateModel.isFixedPrice(cost) || serviceTemplateModel.isVariablePrice(cost) ? cost.price : '')]
          })]
        }), serviceTemplateModel.isVariablePrice(cost) && " / ".concat(serviceCostModel.formattedUnitNameShort(service.cost))]
      }) : /*#__PURE__*/_jsxs(_Fragment, {
        children: [!!discountedPrice.minPrice && /*#__PURE__*/_jsxs(_Fragment, {
          children: ["$", utils.formatNumberWithCommas(discountedPrice.minPrice), ' - ']
        }), discountedPrice.minPrice == null && 'Up to ', "$", discountedPrice.maxPrice instanceof Decimal ? utils.formatNumberWithCommas(discountedPrice.maxPrice) : '', hasDiscount && /*#__PURE__*/_jsxs(_Fragment, {
          children: [' ', /*#__PURE__*/_jsxs("del", {
            children: [!!discountedPrice.minPrice && /*#__PURE__*/_jsxs(_Fragment, {
              children: ["$", utils.formatNumberWithCommas(serviceTemplateModel.isRangePrice(cost) && cost.minPrice != null ? cost.minPrice : ''), ' - ']
            }), "$", utils.formatNumberWithCommas(serviceTemplateModel.isRangePrice(cost) ? cost.maxPrice : '')]
          })]
        })]
      })
    },
    children: discountedPrice == null ? /*#__PURE__*/_jsx(Typography, {
      "data-testid": "uneditable-service-picker-row-discounted-price",
      children: "________"
    }) : discountedPrice instanceof Decimal ? /*#__PURE__*/_jsxs(_Fragment, {
      children: [/*#__PURE__*/_jsx(Typography, {
        "data-testid": "uneditable-service-picker-row-discounted-price",
        children: utils.formatDollarAmount(discountedPrice)
      }), (serviceTemplateModel.isFixedPrice(cost) || !!discount && discount.isPercent()) && hasDiscount && /*#__PURE__*/_jsxs(_Fragment, {
        children: [' ', /*#__PURE__*/_jsxs(Typography, {
          skin: "disabled",
          textDecoration: "line-through",
          "data-testid": "uneditable-service-picker-row-original-price",
          children: ["$", utils.formatNumberWithCommas(serviceTemplateModel.isFixedPrice(cost) || serviceTemplateModel.isVariablePrice(cost) ? cost.price : '')]
        })]
      }), serviceTemplateModel.isVariablePrice(cost) && /*#__PURE__*/_jsxs(Typography, {
        skin: "secondary",
        children: ["/", serviceCostModel.formattedUnitNameShort(service.cost)]
      })]
    }) : /*#__PURE__*/_jsxs(_Fragment, {
      children: [/*#__PURE__*/_jsxs(Typography, {
        "data-testid": "uneditable-service-picker-row-discounted-price",
        children: [discountedPrice.minPrice instanceof Decimal && !discountedPrice.minPrice.equals(0) && /*#__PURE__*/_jsxs(_Fragment, {
          children: [utils.formatDollarAmount(discountedPrice.minPrice), ' - ']
        }), (discountedPrice.minPrice == null || discountedPrice.minPrice.equals(0)) && 'Up to ', "$", discountedPrice.maxPrice instanceof Decimal ? utils.formatNumberWithCommas(discountedPrice.maxPrice) : '']
      }), !!discount && discount.isPercent() && hasDiscount && /*#__PURE__*/_jsxs(_Fragment, {
        children: [' ', /*#__PURE__*/_jsxs(Typography, {
          skin: "disabled",
          textDecoration: "line-through",
          "data-testid": "uneditable-service-picker-row-original-price",
          children: [discountedPrice.minPrice != null && !discountedPrice.minPrice.equals(0) && /*#__PURE__*/_jsxs(_Fragment, {
            children: ["$", utils.formatNumberWithCommas(serviceTemplateModel.isRangePrice(cost) && cost.minPrice != null ? cost.minPrice : ''), ' - ']
          }), (discountedPrice.minPrice == null || discountedPrice.minPrice.equals(0)) && 'Up to ', "$", "$".concat(utils.formatNumberWithCommas(serviceTemplateModel.isRangePrice(cost) ? cost.maxPrice : ''))]
        })]
      })]
    })
  });
}